/**
 * Which queue dialog is open. Kept free of workspace/store imports so the per-tab message store
 * can close a tab's dialog when the tab is released (review Fable F6) without an import cycle.
 */
import { create } from 'zustand';
import type { QueueMessageTarget } from './queueMessageSelection';
import type { QueueMessageRow } from './queueMessagesStore';

export type QueueActionSource = 'toolbar' | 'tree' | 'grid' | 'empty-state' | 'received-banner';
export type QueueDialogArgs = { connectionId: string; queue?: string; source: QueueActionSource; tabId?: string };
export type QueueDialogRequest = QueueDialogArgs & {
  kind: 'add' | 'receive' | 'update' | 'create';
  target?: QueueMessageTarget;
  row?: QueueMessageRow;
  /** Update: the view was decoding Base64 when the dialog opened (review Fable F5). */
  decodeBase64?: boolean;
  onUpdated?: (target: QueueMessageTarget) => void;
};

type State = { request: QueueDialogRequest | null; open: (request: QueueDialogRequest) => void; close: () => void };
export const useQueueDialogStore = create<State>((set) => ({ request: null, open: (request) => set({ request }), close: () => set({ request: null }) }));

/** A released tab takes its open dialog with it; the dialog's own cleanup cancels its in-flight request. */
export function closeQueueDialogsForTab(tabId: string): void {
  if (useQueueDialogStore.getState().request?.tabId === tabId) useQueueDialogStore.getState().close();
}
